import { INTERSECTION_ROOT_MARGIN_DEFAULT } from '../tokens/intersection-root-margin'

export const rootMarginFactory = (rootMargin: string | null): string => rootMargin || INTERSECTION_ROOT_MARGIN_DEFAULT
